/* MkaeSense: Canada and USA winter sunlight map for the solar check page. Leaflet loads only when the visitor opens the map. */
(function () {
  'use strict';
  var root = document.querySelector('.mk-sc');
  if (!root || root.__mkmap) return; root.__mkmap = 1;
  var $ = function (s) { return root.querySelector(s); };
  var EFF = 0.65;
  var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  var CITIES = [
    ['Victoria', 48.43, -123.37], ['Vancouver', 49.28, -123.12], ['Kelowna', 49.89, -119.50], ['Prince George', 53.92, -122.75],
    ['Calgary', 51.05, -114.07], ['Edmonton', 53.55, -113.49], ['Saskatoon', 52.13, -106.67], ['Regina', 50.45, -104.62],
    ['Winnipeg', 49.90, -97.14], ['Thunder Bay', 48.38, -89.25], ['Sault Ste. Marie', 46.52, -84.35], ['Sudbury', 46.49, -81.00],
    ['Muskoka (Gravenhurst)', 44.92, -79.37], ['Toronto', 43.65, -79.38], ['Ottawa', 45.42, -75.70], ['Montréal', 45.50, -73.57],
    ['Québec City', 46.81, -71.21], ['Fredericton', 45.96, -66.64], ['Halifax', 44.65, -63.58], ["St. John's", 47.56, -52.71],
    ['Whitehorse', 60.72, -135.06], ['Yellowknife', 62.45, -114.37], ['Iqaluit', 63.75, -68.52],
    ['Seattle', 47.61, -122.33], ['Portland, OR', 45.52, -122.68], ['San Francisco', 37.77, -122.42], ['Los Angeles', 34.05, -118.24],
    ['Phoenix', 33.45, -112.07], ['Boise', 43.62, -116.20], ['Salt Lake City', 40.76, -111.89], ['Denver', 39.74, -104.99],
    ['Billings', 45.78, -108.50], ['Dallas', 32.78, -96.80], ['Houston', 29.76, -95.37], ['Kansas City', 39.10, -94.58],
    ['Minneapolis', 44.98, -93.27], ['Chicago', 41.88, -87.63], ['Detroit', 42.33, -83.05], ['Atlanta', 33.75, -84.39],
    ['Miami', 25.76, -80.19], ['Pittsburgh', 40.44, -80.00], ['Buffalo', 42.89, -78.88], ['Washington, DC', 38.91, -77.04],
    ['New York', 40.71, -74.01], ['Boston', 42.36, -71.06], ['Burlington, VT', 44.48, -73.21], ['Portland, ME', 43.66, -70.26],
    ['Anchorage', 61.22, -149.90]
  ];
  var TIERS = [
    { min: 1.5, c: '#5ee08a', t: 'Stays charged all winter' },
    { min: 1, c: '#9fd36b', t: 'Should work, little to spare' },
    { min: 0.6, c: '#ffc857', t: 'Needs help in the darkest month' },
    { min: -1, c: '#ffb86b', t: 'Winter needs a plan' }
  ];
  var REG = { ca: [[43, -136], [65, -54]], us: [[24.5, -125], [49.5, -66.5]], all: [[24.5, -136], [65, -52]] };
  var FULL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  var css = '.mk-sc__regions{display:flex;gap:8px;margin:0 0 12px}.mk-sc__regions button{min-height:40px;padding:0 18px;border-radius:999px;border:1px solid rgba(255,255,255,.18);background:rgba(255,255,255,.05);color:#f5f5f7;font:600 14px Inter,sans-serif;cursor:pointer}.mk-sc__regions button.on{background:#0071e3;border-color:#0071e3}.mk-sc__regions[hidden]{display:none}' +
    '.mk-sc__mapwrap{margin:36px 0 0}.mk-sc__mapwrap h2{margin:0 0 8px;font-size:clamp(1.25rem,4.4vw,1.7rem);letter-spacing:-.025em;color:#fff}' +
    '.mk-sc__mapwrap p{margin:0 0 14px;color:#a1a1a6;font-size:15px;line-height:1.55;max-width:60ch}' +
    '.mk-sc__map{height:420px;border-radius:18px;border:1px solid rgba(255,255,255,.14);overflow:hidden;background:#06080c;position:relative}' +
    '@media(max-width:600px){.mk-sc__map{height:340px}}' +
    '.mk-sc__map .leaflet-tile-pane{filter:invert(1) hue-rotate(200deg) brightness(.82) contrast(.95) saturate(.45)}' +
    '.mk-sc__map .leaflet-container{background:#06080c;font-family:Inter,system-ui,sans-serif}' +
    '.mk-sc__map .leaflet-control-attribution{background:rgba(0,0,0,.6);color:#a1a1a6;font-size:10px}.mk-sc__map .leaflet-control-attribution a{color:#8ab4ff}' +
    '.mk-sc__map .leaflet-tooltip{background:#0b0d11;color:#f5f5f7;border:1px solid rgba(255,255,255,.2);border-radius:10px;padding:7px 10px;font:600 12.5px/1.35 Inter,system-ui,sans-serif;box-shadow:0 8px 24px rgba(0,0,0,.6)}' +
    '.mk-sc__map .leaflet-tooltip small{display:block;font-weight:500;color:#a1a1a6}' +
    '.mk-sc__map .leaflet-tooltip-top:before{border-top-color:#0b0d11}' +
    '.mk-sc__mleg{display:flex;flex-wrap:wrap;gap:8px 16px;margin:12px 0 0;font-size:13px;color:#a1a1a6}.mk-sc__mleg span{display:inline-flex;align-items:center;gap:7px}.mk-sc__mleg i{width:11px;height:11px;border-radius:50%;display:inline-block}' +
    '.mk-sc__mnote{margin:10px 0 0 !important;font-size:13px !important}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var fine = $('.mk-sc__fine');
  var wrap = document.createElement('div');
  wrap.className = 'mk-sc__mapwrap';
  wrap.innerHTML = '<h2>Winter sunlight map: Canada and the USA</h2>' +
    '<p>See how the darkest month looks across Canada and the USA for your panel and camera settings. Tap any dot, or anywhere on the map, to check that spot.</p>' +
    '<button type="button" class="mk-sc__btn" data-map-open>Show the map</button>' +
    '<div class="mk-sc__regions" data-regions hidden><button type="button" data-r="ca" class="on">Canada</button><button type="button" data-r="us">USA</button><button type="button" data-r="all">Both</button></div>' +
    '<div class="mk-sc__map" data-map hidden></div>' +
    '<div class="mk-sc__mleg" data-mleg hidden></div>' +
    '<p class="mk-sc__mnote" data-mnote hidden></p>';
  if (fine && fine.parentNode) fine.parentNode.insertBefore(wrap, fine); else root.appendChild(wrap);

  var mapEl = wrap.querySelector('[data-map]'), leg = wrap.querySelector('[data-mleg]'), note = wrap.querySelector('[data-mnote]');
  var res = $('[data-res]');
  var regs = wrap.querySelector('[data-regions]');
  var map, markers = [], pin, pending = false, queue = [], running = 0;

  function sel(s) { var e = $(s); return e ? Number(e.value) : 0; }
  function tierOf(psh) {
    var worst = Math.min.apply(null, psh), wi = psh.indexOf(worst);
    var ratio = sel('[data-panel]') * worst * sel('[data-tilt]') * EFF / sel('[data-use]');
    for (var i = 0; i < TIERS.length; i++) if (ratio >= TIERS[i].min) return { c: TIERS[i].c, t: TIERS[i].t, worst: worst, month: FULL[wi], ratio: ratio };
    return TIERS[3];
  }

  function ckey(lat, lon) { return 'mkpsh:' + lat.toFixed(2) + ',' + lon.toFixed(2); }
  function cget(k) { try { var v = JSON.parse(localStorage.getItem(k)); if (v && Date.now() - v.t < 2592e6) return v.p; } catch (e) { } return null; }
  function cset(k, p) { try { localStorage.setItem(k, JSON.stringify({ t: Date.now(), p: p })); } catch (e) { } }
  function getPSH(lat, lon) {
    var k = ckey(lat, lon), c = cget(k);
    if (c) return Promise.resolve(c);
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var tm = setTimeout(function () { ctl && ctl.abort(); }, 25000);
    var url = 'https://power.larc.nasa.gov/api/temporal/climatology/point?parameters=ALLSKY_SFC_SW_DWN&community=RE&longitude=' + lon.toFixed(3) + '&latitude=' + lat.toFixed(3) + '&format=JSON';
    return fetch(url, ctl ? { signal: ctl.signal } : {}).then(function (r) { clearTimeout(tm); if (!r.ok) throw 0; return r.json(); }).then(function (d) {
      var p = d && d.properties && d.properties.parameter && d.properties.parameter.ALLSKY_SFC_SW_DWN;
      if (!p) throw 0;
      var a = MONTHS.map(function (m) { return Number(p[m]); });
      if (a.some(function (v) { return !isFinite(v) || v < 0; })) throw 0;
      cset(k, a); return a;
    });
  }

  function paint(m) {
    if (!m.psh) { m.setStyle({ fillColor: '#6e6e73', color: '#fff', fillOpacity: .55 }); m.setTooltipContent('<b>' + m.__name + '</b><small>Loading sunlight data…</small>'); return; }
    var t = tierOf(m.psh);
    m.setStyle({ fillColor: t.c, color: '#fff', fillOpacity: .95 });
    m.setTooltipContent('<b>' + m.__name + '</b><small>' + t.t + '</small><small>' + t.month + ': ' + t.worst.toFixed(1) + ' full-sun hours a day</small>');
  }
  function repaint() { markers.forEach(paint); legend(); }

  function legend() {
    var W = sel('[data-panel]'), u = sel('[data-use]');
    var usage = ({ 3: 'a quiet', 6: 'a typical', 12: 'a busy', 30: 'an always-on' })[u] || 'a typical';
    leg.innerHTML = TIERS.map(function (t) { return '<span><i style="background:' + t.c + '"></i>' + t.t + '</span>'; }).join('') + '<span><i style="background:#6e6e73"></i>Loading</span>';
    note.textContent = 'Colours are for a ' + W + ' W panel and ' + usage + ' camera. Change the options at the top of the page and the map updates.';
  }

  function pump() {
    while (running < 3 && queue.length) {
      (function (m) {
        running++;
        getPSH(m.__lat, m.__lon).then(function (a) { m.psh = a; paint(m); }).catch(function () { m.setTooltipContent('<b>' + m.__name + '</b><small>No data right now. Tap to try.</small>'); })
          .then(function () { running--; pump(); });
      })(queue.shift());
    }
  }

  function pick(lat, lon, label) {
    pending = true;
    if (pin) pin.setLatLng([lat, lon]); else pin = L.circleMarker([lat, lon], { radius: 13, color: '#4d9fff', weight: 2, fill: false, interactive: false }).addTo(map);
    root.dispatchEvent(new CustomEvent('mk:pick', { detail: { lat: lat, lon: lon, label: label } }));
  }
  if (res && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (pending && !res.hidden) { pending = false; res.style.scrollMarginTop = '96px'; try { res.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { res.scrollIntoView(); } }
    }).observe(res, { attributes: true, attributeFilter: ['hidden'] });
  }

  function init() {
    map = L.map(mapEl, { attributionControl: false, scrollWheelZoom: false, worldCopyJump: false, minZoom: 2, maxZoom: 9, zoomSnap: 0.25 });
    map.fitBounds(REG.ca, { padding: [4, 4] });
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 9, attribution: '© <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>' }).addTo(map);
    L.control.attribution({ prefix: false }).addTo(map);
    CITIES.forEach(function (c) {
      var m = L.circleMarker([c[1], c[2]], { radius: 9, weight: 2, color: '#fff', fillColor: '#6e6e73', fillOpacity: .55 }).addTo(map);
      m.__name = c[0]; m.__lat = c[1]; m.__lon = c[2];
      m.bindTooltip('', { direction: 'top', offset: [0, -8] });
      m.on('click', function (e) { L.DomEvent.stopPropagation(e); pick(c[1], c[2], c[0]); if (!m.psh) { queue.unshift(m); pump(); } });
      markers.push(m); queue.push(m); paint(m);
    });
    map.on('click', function (e) {
      var lat = e.latlng.lat, lon = e.latlng.lng;
      pick(lat, lon, 'Your pick on the map (' + lat.toFixed(2) + ', ' + lon.toFixed(2) + ')');
    });
    ['[data-panel]', '[data-use]', '[data-tilt]'].forEach(function (s) { var e = $(s); if (e) e.addEventListener('change', repaint); });
    regs.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-r]'); if (!b) return;
      Array.prototype.forEach.call(regs.children, function (x) { x.classList.toggle('on', x === b); });
      map.fitBounds(REG[b.getAttribute('data-r')], { padding: [4, 4] });
    });
    legend(); pump();
    setTimeout(function () { map.invalidateSize(); }, 200);
  }

  function loadLeaflet(cb) {
    if (window.L && window.L.map) return cb();
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css'; document.head.appendChild(l);
    var s = document.createElement('script'); s.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
    s.onload = cb; s.onerror = function () { btn.disabled = false; btn.textContent = 'Map could not load. Try again'; mapEl.hidden = true; };
    document.head.appendChild(s);
  }

  var btn = wrap.querySelector('[data-map-open]');
  btn.addEventListener('click', function () {
    btn.disabled = true; btn.textContent = 'Loading the map…';
    loadLeaflet(function () {
      btn.hidden = true; regs.hidden = false; mapEl.hidden = false; leg.hidden = false; note.hidden = false;
      init();
    });
  });
})();
